import React from 'react';
import { Button } from '../Button';
import { PhoneCall } from 'lucide-react';
import ReactGA from 'react-ga4';

export function FinalCtaSection() {
  return (
    <section aria-label="Book a consultation" className="relative py-12 sm:py-24 bg-primary overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1618221381711-42ca8ab6e908?auto=format&fit=crop&q=50&w=1000&fm=webp" 
          alt="Luxury interior design by Aura Spaces" 
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary via-primary/80 to-transparent" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <h2 className="text-2xl sm:text-5xl font-poppins font-bold text-white mb-4 sm:mb-6 leading-tight text-balance">
          Let's Build Your Dream Space
        </h2>
        <p className="text-sm sm:text-xl text-gray-300 mb-8 sm:mb-10 max-w-2xl mx-auto">
          Take the first step towards a beautifully designed space. Our experts are ready to bring your vision to life.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
          <Button variant="accent" className="w-full sm:w-auto px-8 py-3.5 sm:py-4" onClick={() => { ReactGA.event({ category: 'CTA', action: 'Clicked Book Consultation' }); document.getElementById('consultation')?.scrollIntoView({ behavior: 'smooth' }); }}>
            Book Consultation
          </Button>
          <Button variant="secondary" className="w-full sm:w-auto group px-8 py-3.5 sm:py-4" onClick={() => ReactGA.event({ category: 'CTA', action: 'Clicked Phone Call' })}>
            <PhoneCall className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-primary group-hover:text-primary transition-colors" />
            <span className="text-primary text-sm sm:text-base font-semibold">+91 9989697942</span>
          </Button>
        </div>
      </div>
    </section>
  );
}
